import { createSlice } from '@reduxjs/toolkit';

export interface ModalDetails {
  isOpen: boolean;
}

const initialState: ModalDetails = {
  isOpen: false,
};

const modal = createSlice({
  name: 'user',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modal.actions;

export default modal.reducer;
